export const noAccessRoutes = [
  {
    path: '/no-access',
    component: () => import('./NoAccessView.vue'),
  },
]
